<template>
  <div class="wrapper" v-if="homeLoaded"></div>
  <div class="home" v-if="!homeLoaded">
    <!-- <button @click="$router.push('/vuemask')">VUE MASK</button> -->
    <!-- <button @click="$router.push('/icons')">ICONES</button> -->
    <ModalEntrada v-if="acesso_home.modalEntrada.habilitado && !isRP" />
    <Campanhas v-if="acesso_home.campanhas.habilitado" />
    <div class="container-filho" v-if="resgateParcialSolicitado" style="margin-top: 20px; margin-bottom: 20px">
      <MiniCardAcao :texto="'Acompanhe aqui seu Resgate Parcial'" :router="'/resgatesolicitado'" />
    </div>
    <TrocaUsuario v-if="acesso_home.trocaUsuario.habilitado" />
    <!-- @atualizarHomeNovaChave="trocarChave" -->
    <AcessoRapido v-if="acesso_home.acessoRapido.habilitado" :titulo="acesso_home.acessoRapido.titulo" />
    <ProjetoDeVida v-if="acesso_home.projetoDeVida.habilitado" :titulo="acesso_home.projetoDeVida.titulo"
      :contratacao_contrib="contratacaoContrib" />
    <!-- MinhasCoberturas -->
    <div class="container-filho" v-if="acesso_home.minhasCoberturas.habilitado">
      <MinhasCoberturas :titulo="acesso_home.minhasCoberturas.titulo" :contratadas="coberturasContratadas" />
    </div>
    <!-- MinhaContribuicao -->
    <div class="container-filho" v-if="acesso_home.minhaContribuicao.habilitado">
      <MinhaContribuicao :titulo="acesso_home.minhaContribuicao.titulo" :contratacao_contrib="contratacaoContrib" />
    </div>

    <!-- Beneficio -->
    <!-- <div class="container-filho" v-if="participante.elegibilidade.beneficio">
      <Beneficio></Beneficio>
    </div> -->

    <Emprestimo v-if="
      statusParticipacao === 'Antigo' &&
      emprestimoHabilitado &&
      acesso_home.emprestimo.habilitado
    " :titulo="acesso_home.emprestimo.titulo" :btn_acao="true" />
    <MaisAmigosCard v-if="acesso_home.maisAmigos.habilitado" />
    <VideosCardHome v-if="acesso_home.videos.habilitado" :titulo="acesso_home.videos.titulo" />
    <br />
    <br />
  </div>
  <!-- <button @click="logout">logout</button> -->
  <FooterHome v-if="!homeLoaded" :version="appVersion" />
</template>

<script>
import firebase from "firebase/compat/app";
import "firebase/compat/analytics";
import "firebase/compat/auth";
import firebaseConfig from "@/firebase/firebase-config.json";
import ModalEntrada from "@/components/ModalEntrada.vue";
import TrocaUsuario from "@/components/TrocaUsuario.vue";
import AcessoRapido from "@/components/AcessoRapido.vue";
import ProjetoDeVida from "@/components/ProjetoDeVida.vue";
import MinhasCoberturas from "@/components/MinhasCoberturas.vue";
import MinhaContribuicao from "@/components/MinhaContribuicao.vue";
import MiniCardAcao from "@/components/MiniCardAcao.vue";
import Emprestimo from "@/components/Emprestimo.vue";
import MaisAmigosCard from "@/components/MaisAmigosCard.vue";
import VideosCardHome from "@/components/videosCardHome.vue";
import FooterHome from "@/components/FooterHome.vue";
import FirebaseHelper from "@/service/FirebaseHelper";
import { mapGetters, mapActions } from "vuex";
import GraficoProjetoVida from "@/components/GraficoProjetoVida.vue";
import Campanhas from "@/components/Campanhas.vue";

const auth = firebase.auth();
const situacaoParticipantePlanoEncerrado = [
  "Com Resgate Pagamento Único",
  "Com Portabilidade",
  "Com Resgate Parcelado",
  "Esgotamento de Saldo",
  "Pedido de Cancelamento sem Resgate",
  "Renda - Pagamento Único",
  "Saldo PJ sem Resgate",
  "",
];

export default {
  name: "HomeView",
  components: {
    GraficoProjetoVida,
    ModalEntrada,
    TrocaUsuario,
    FooterHome,
    AcessoRapido,
    ProjetoDeVida,
    MiniCardAcao,
    MinhaContribuicao,
    MinhasCoberturas,
    MaisAmigosCard,
    Emprestimo,
    VideosCardHome,
    Campanhas,
    //  Beneficio
  },
  data() {
    return {
      homeLoaded: false, // Controla se o SplashPage está ativo
      acesso_home: {
        modalEntrada: true,
        campanhas: true,
        trocaUsuario: true,
        acessoRapido: false,
        projetoDeVida: true,
        minhasCoberturas: true,
        minhaContribuicao: true,
        emprestimo: true,
        maisAmigos: true,
        videos: true,
      },
      firebaseHelper: new FirebaseHelper(),
      appVersion: "",
      appVersionPWA: "",
      coberturasContratadas: {},
      meses: [
        { nome: "Jan", valor: "01" },
        { nome: "Fev", valor: "02" },
        { nome: "Mar", valor: "03" },
        { nome: "Abr", valor: "04" },
        { nome: "Mai", valor: "05" },
        { nome: "Jun", valor: "06" },
        { nome: "Jul", valor: "07" },
        { nome: "Ago", valor: "08" },
        { nome: "Set", valor: "09" },
        { nome: "Out", valor: "10" },
        { nome: "Nov", valor: "11" },
        { nome: "Dez", valor: "12" },
      ],
    };
  },
  computed: {
    ...mapGetters({
      participante: "participante",
      login: "login",
      chave: "chave",
      cpf: "cpf",
      uid: "uid",
      plano: "plano",
      settingsDadosEntidade: "settingsDadosEntidade",
      projetoFirebase: "projetoFirebase",
      novaChave: "novaChave",
      statusParticipacao: "statusParticipacao",
      isRP: "isRP",
      ultimaChave: "ultimaChave",
      ultimoUid: "ultimoUid",
      chavePrincipal: "chavePrincipal",
    }),
    gettersNovaChave() {
      console.log("this.novaChave", this.novaChave);
      return this.novaChave;
    },
  },
  watch: {
    gettersNovaChave(newval, oldval) {
      console.log("newval", newval);
      console.log("oldval", oldval);
      delete this.$root.$route.query.chave;
      if (newval && newval !== oldval) {
        this.trocarChave(newval);
      }
    },
  },
  async created() {
    if (this.navegador === 'Windows' || this.navegador === 'macOS') {
      this.appVersion = localStorage.getItem('appVersion');
      console.log("this.appVersion", this.appVersion);
      const res = await this.firebaseHelper.getVersaoPWA();
      console.log("this.appVersionPWA", res);
      this.appVersionPWA = res;
      if (res !== this.appVersion) {
        console.log("entrou no if");
        await this.firebaseHelper.signOut(this.auth);
        location.reload();
      }
    }

    // this.firebaseHelper.getVersaoBD().then((res) => {
    //   this.appVersion = res;
    // });
  },
  mounted() {
    if (auth && auth.currentUser && auth.currentUser.uid) {
      this.atualizarEstadoUid(auth.currentUser.uid);
    } else {
      this.$router.push("/login");
    }
    if (this.$route.query.chave) {
      this.base_spinner.style.display = "flex";
      this.homeLoaded = true;
      this.trocarChave(this.$route.query.chave);
      this.$router.replace({ query: { chave: "" } });
      return;
    }
    if (this.$route.query.novaChave) {
      this.base_spinner.style.display = "flex";
      this.homeLoaded = true;
      this.trocarChave(this.$route.query.novaChave);
      this.$router.replace({ query: { novaChave: "" } });
      return;
    }
    this.consultaParticipante();
  },
  methods: {
    ...mapActions([
      "atualizarEstadoParticipante",
      "atualizarEstadoLogin",
      "atualizarEstadoChave",
      "atualizarEstadoCpf",
      "atualizarEstadoUid",
      "atualizarEstadoPlano",
      "atualizarEstadoSettingsDadosEntidade",
      "atualizarEstadoProjetoFirebase",
      "atualizarStatusParticipacao",
      "atualizarEstadoDataBaseReserva",
      "atualizarEstadoCadastroIncompleto",
      "atualizarEstadoPerfilInvestimento",
      "atualizarEstadoRegimeTributacao",
      "atualizarEstadoContratacaoContrib",
      "atualizarEstadoContratacaoEmp",
      "atualizarEstadoContratacaoSeg",
      "atualizarEstadoSettingsSimuladorRenda",
      "atualizarEstadoNovaChave",
      "atualizarEstadoIsRP",
      "atualizarEstadoUltimaChave",
      "atualizarEstadoUltimoUid",
      "atualizarEstadoDadosContratacaoResgate",
    ]),
    async logout() {
      await this.firebaseHelper.signOut(this.auth);
    },
    async trocarChave(novachave) {
      this.base_spinner.style.display = "flex";
      this.homeLoaded = true;
      delete this.$root.$route.query.novaChave;
      this.atualizarEstadoChave(novachave);
      this.atualizarEstadoUltimaChave(novachave);
      await this.getParticipantePorChave(novachave, auth.currentUser.uid);
      this.loadParticipante();
    },
    fecharModal(modal) {
      this[modal] = false;
    },
    async getParticipantePorChave(chave, uid) {
      let p_login = await this.firebaseHelper.verificaPrimeiroLogin();
      if (p_login) {
        this.atualizarEstadoChave(chave);
        this.$router.push({
          path: "/primeirologinconfirmacao",
          query: { uid: uid },
        });
      } else {
        console.log("this.chave", this.chave);

        // Atualiza o último acesso na chave atual
        if (!this.chave.includes("RP-")) {
          await this.firebaseHelper.atualizaUltimoAcesso(this.chave);
        }

        if (
          this.chave.includes("RP-") &&
          (await this.firebaseHelper.validaRP(this.uid))
        ) {
          this.atualizarEstadoIsRP(true);
          this.$router.push("/trocaparticipacao"); //se for RP e não tiver nenhum dado de outra chave, direciona direto para o trocaParticipacao
        } else {
          let participante = await this.firebaseHelper.getParticipantePorChave(
            chave,
            uid
          );
          participante.statusParticipanteApp = "Antigo";
          this.atualizarEstadoParticipante(participante);
          console.log("Home participante", participante);
          this.atualizarEstadoCpf(participante.data.cadastro.informacoes_pessoais.cpf);
          this.atualizarEstadoUltimaChave(chave);
          this.atualizarStatusParticipacao(
            participante.statusParticipanteApp || "Antigo"
          );
        }
      }
    },
    abrirModal() {
      this.modal_teste = true;
    },
    async consultaParticipante() {
      try {
        if (!this.auth.currentUser) {
          this.$router.push("/login");
          return;
        }
        this.base_spinner.style.display = "flex";
        this.homeLoaded = true;
        console.log("this.chave 1", this.chave);
        console.log("this.chavePrincipal 2", this.chavePrincipal);
        if (
          this.chave.includes("RP-") &&
          (await this.firebaseHelper.validaRP(this.uid))
        ) {
          this.atualizarEstadoIsRP(true);
          this.$router.push("/trocaparticipacao"); //se for RP e não tiver nenhum dado de outra chave, direciona direto para o trocaParticipacao
        } else {
          if (!this.participante || Object.keys(this.participante).length === 0) {
            await this.getParticipantePorChave(this.chave, auth.currentUser.uid);
          }
          if (this.chave !== "RP-0") {
            this.loadParticipante();
          } else {
            this.atualizarStatusParticipacao("Novo");
            this.$router.push("/errologin");
          }
        }
      } catch (e) {
        this.base_spinner.style.display = "none";
        this.atualizarStatusParticipacao("Novo");
        if (this.isRP) {
          this.$router.push("/trocaparticipacao");
        } else {
          this.$router.push("/errologin");
        }
      }
    },
    async logout() {
      await this.firebaseHelper.signOut(this.auth);
      if (!this.auth.currentUser) {
        this.$router.push("/login");
      }
    },
    openModal() {
      document.getElementById("modalteste").style.display = "flex";
    },
    async loadParticipante() {
      if (this.participante.data) {
        this.atualizarEstadoPlano(this.participante.data.cadastro.dados_plano.plano);
      }
      await this.verificarBeneficios();
      this.habilitaEmprestimo();
      this.getContratacoes();
      if (this.participante.data) {
        const acesso_home = await this.firebaseHelper.getAcessoHome(
          this.participante.data.cadastro.dados_plano.plano
        );
        const settings_dados_entidade = this.firebaseHelper.getDadosEntidade(
          this.participante.data.cadastro.dados_plano.plano
        );
        const settings_simulador_renda = this.firebaseHelper.getSimuladorRendaSettings(
          this.participante.data.cadastro.dados_plano.plano
        );
        const retPromisesPart = await Promise.all([
          acesso_home,
          settings_dados_entidade,
          settings_simulador_renda,
        ]);
        this.emitter.emit("disabled_navbar", false);
        this.acesso_home = retPromisesPart[0];
        this.atualizarEstadoSettingsDadosEntidade(retPromisesPart[1]);
        this.atualizarEstadoSettingsSimuladorRenda(retPromisesPart[2]);
        this.atualizarEstadoProjetoFirebase(firebaseConfig.result.sdkConfig.projectId);
        this.emitter.emit("atualizaNavbar", this.plano);
        this.emitter.emit("atualizaServicos");
      }
      let cadastro_incompleto = false;
      if (
        this.participante.data &&
        this.participante.data.cadastro.adesao_digital &&
        this.participante.data.cadastro.adesao_digital.cadastro_incompleto
      ) {
        cadastro_incompleto = this.participante.data.cadastro.adesao_digital
          .cadastro_incompleto;
      }
      var data;
      if (
        this.participante.rdi &&
        this.participante.rdi.historicoReserva &&
        this.participante.rdi.historicoReserva.posicao
      ) {
        data = new Date(this.participante.rdi.historicoReserva.posicao);
      } else {
        data = new Date();
      }
      var mes = this.meses.find((m) => Number(m.valor) === data.getMonth() + 1);
      this.atualizarEstadoDataBaseReserva(`${mes.nome}/${data.getFullYear()}` || "");
      this.atualizarEstadoCadastroIncompleto(cadastro_incompleto || "");
      if (this.participante.data) {
        this.atualizarEstadoPerfilInvestimento(
          this.participante.data.cadastro.dados_plano.perfil_investimento || ""
        );
        this.atualizarEstadoRegimeTributacao(
          this.participante.data.cadastro.dados_plano.regime_tributacao ||
          "Regime Progressivo"
        );
      }
      if (this.chave !== "RP-0" && cadastro_incompleto) {
        this.atualizarStatusParticipacao("Novo");
        this.showCardCadastroIncompleto = true;
        this.$router.push({
          path: "/cadastroincompleto",
          query: { participante: this.participante },
        });
      }
      this.base_spinner.style.display = "none";
      this.homeLoaded = false;
    },
    verificarBeneficios() {
      if (this.participante.rdi && this.participante.rdi.resgateSolicitado) {
        if (
          this.participante.rdi.resgateSolicitado.tipo_solicitacao === "Resgate Total" &&
          (this.participante.rdi.resgateSolicitado.solicitacao_situacao ===
            "Solicitado" ||
            this.participante.rdi.resgateSolicitado.solicitacao_situacao === "Aprovado" ||
            this.participante.rdi.resgateSolicitado.solicitacao_situacao ===
            "Concluído" ||
            this.participante.rdi.resgateSolicitado.solicitacao_situacao ===
            "Em Andamento")
        ) {
          this.$router.push({
            path: "/resgatesolicitado",
            query: { resgateTotalSolicitado: this.participante.rdi.resgateSolicitado },
          });
        }
        if (
          this.participante.rdi.resgateSolicitado.tipo_solicitacao ===
          "Resgate Parcial" &&
          (this.participante.rdi.resgateSolicitado.solicitacao_situacao ===
            "Solicitado" ||
            this.participante.rdi.resgateSolicitado.solicitacao_situacao ===
            "Em andamento")
        ) {
          this.resgateParcialSolicitado = this.participante.rdi.resgateSolicitado;
          this.atualizarEstadoDadosContratacaoResgate(this.resgateParcialSolicitado);
        } else {
          this.resgateParcialSolicitado = null;
        }
      }
    },
    habilitaEmprestimo() {
      this.emprestimoHabilitado =
        ((this.participante.projetoVida || {}).emprestimo || {}).vigente || false;
      if (((this.participante.projetoVida || {}).emprestimo || {}).vigente) {
        this.emprestimoHabilitado =
          this.participante.projetoVida.emprestimo.disponivel > 0;
      } else {
        this.emprestimoHabilitado = false;
      }
    },
    validarSituacaoPlano(plano) {
      if (situacaoParticipantePlanoEncerrado.includes(plano.situacao_plano)) {
        this.$root.$router.push("/planoencerrado");
      }
    },
    getContratacoes() {
      let contratacaoContrib = false;
      let contratacaoEmp = false;
      let contratacaoSeg = false;
      if (this.participante.contratacoes) {
        contratacaoContrib = this.participante.contratacoes.contrib
          ? this.participante.contratacoes.contrib
          : false;
        contratacaoEmp = this.participante.contratacoes.emprestimo
          ? this.participante.contratacoes.emprestimo
          : false;
        contratacaoSeg = this.participante.contratacoes.seguro
          ? this.participante.contratacoes.seguro
          : false;
      }
      this.atualizarEstadoContratacaoContrib(contratacaoContrib);
      this.atualizarEstadoContratacaoEmp(contratacaoEmp);
      this.atualizarEstadoContratacaoSeg(contratacaoSeg);
    },
  },
};
</script>

<style>
.container-filho {
  padding: 0 15px;
}

.material-icons {
  font-size: 25px;
  padding: 3px;
}
</style>
